import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { dealerApi, DEALER_TOKEN_KEY } from "@/lib/api";

const DealerAuthContext = createContext(null);

function tokenValid(token) {
  if (!token) return false;
  try {
    let b64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    while (b64.length % 4) b64 += "=";
    const payload = JSON.parse(atob(b64));
    if (payload.exp && payload.exp * 1000 <= Date.now()) return false;
    return true;
  } catch {
    return false;
  }
}

export function DealerAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(DEALER_TOKEN_KEY));

  const login = useCallback(async (username, password) => {
    const { data } = await dealerApi.post("/dealer/login", { username, password });
    localStorage.setItem(DEALER_TOKEN_KEY, data.token);
    setToken(data.token);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(DEALER_TOKEN_KEY);
    setToken(null);
  }, []);

  useEffect(() => {
    if (token && !tokenValid(token)) {
      localStorage.removeItem(DEALER_TOKEN_KEY);
      setToken(null);
    }
  }, [token]);

  return (
    <DealerAuthContext.Provider value={{ token, isAuthed: tokenValid(token), login, logout }}>
      {children}
    </DealerAuthContext.Provider>
  );
}

export function useDealerAuth() {
  const ctx = useContext(DealerAuthContext);
  if (!ctx) throw new Error("useDealerAuth must be used within DealerAuthProvider");
  return ctx;
}
